/**
 * SOLID Review
 * S — Strong. One concern: the ad slot's use case, built once.
 * O — Good. A new ad act is one use case built here.
 * L — N/A — no inheritance hierarchy.
 * I — Strong. Exactly the ad op of `ClientUseCases`.
 * D — Good. Two port interfaces and the shared steps, injected; what it builds is held by role (`IUseCase`).
 */
import type { IPortClientDecisions } from '../../domain/ports/ClientDecisions.contract';
import type { ICommandNothing } from '../../domain/ports/schemas/TableMoves';
import type { IPortClientAdsServer } from '../ports/contracts';
import type { TPortOutcome } from '../ports/PortResult';
import type { IUseCase } from '../uml-components/IUseCase';
import type { ClientSteps } from '../shared/ClientSteps';
import { LoadAdConfigUseCase, type IConfigDepAds } from './LoadAdConfigUseCase';

export interface IConfigDepAdsContext {
  readonly decisions: IPortClientDecisions;
  readonly ads: IPortClientAdsServer;
  /** The one serial section, shared with every other context. */
  readonly steps: ClientSteps;
}

/** The ad slot (frontend strict-ports plan, FE4d; a use case since frontend-application-oo P4). */
export class AdsContext {
  /** Ask for the seated free player's ad provider — once per player; a premium player never asks. */
  readonly loadAdConfig: IUseCase<ICommandNothing, TPortOutcome>;

  constructor(deps: IConfigDepAdsContext) {
    const slot: IConfigDepAds = { decisions: deps.decisions, ads: deps.ads, step: deps.steps.onSession };
    this.loadAdConfig = new LoadAdConfigUseCase(slot);
  }
}
